/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListApprovedToolsUsersParams,
  SchemaValidationErrorResponse,
  ToolsUserRequestInput,
  User,
  UserUnion
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Partner Tools Users
 */
export const listApprovedToolsUsers = (
    params?: MaybeRefOrGetter<ListApprovedToolsUsersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<User[]>(
      {url: `/tools-users/approved`, method: 'GET',
        params, signal
    },
      );
    }




export const getListApprovedToolsUsersQueryKey = (params?: MaybeRefOrGetter<ListApprovedToolsUsersParams>,) => {
    return [
    'tools-users','approved', ...(params ? [params] : [])
    ] as const;
    }


export const getListApprovedToolsUsersQueryOptions = <TData = Awaited<ReturnType<typeof listApprovedToolsUsers>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListApprovedToolsUsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApprovedToolsUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListApprovedToolsUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApprovedToolsUsers>>> = ({ signal }) => listApprovedToolsUsers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApprovedToolsUsers>>, TError, TData>
}

export type ListApprovedToolsUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listApprovedToolsUsers>>>
export type ListApprovedToolsUsersQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of Partner Tools Users
 */

export function useListApprovedToolsUsers<TData = Awaited<ReturnType<typeof listApprovedToolsUsers>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListApprovedToolsUsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApprovedToolsUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListApprovedToolsUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Current Tools User Details
 */
export const getCurrentToolsUser = (

 signal?: AbortSignal
) => {


      return axiosClient<UserUnion>(
      {url: `/tools-users/current`, method: 'GET', signal
    },
      );
    }




export const getGetCurrentToolsUserQueryKey = () => {
    return [
    'tools-users','current'
    ] as const;
    }


export const getGetCurrentToolsUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentToolsUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentToolsUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCurrentToolsUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentToolsUser>>> = ({ signal }) => getCurrentToolsUser(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentToolsUser>>, TError, TData>
}

export type GetCurrentToolsUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentToolsUser>>>
export type GetCurrentToolsUserQueryError = ErrorType<unknown>


/**
 * @summary Current Tools User Details
 */

export function useGetCurrentToolsUser<TData = Awaited<ReturnType<typeof getCurrentToolsUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentToolsUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentToolsUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Tools User
 */
export const updateToolsUser = (
    userId: MaybeRefOrGetter<string>,
    toolsUserRequestInput: MaybeRefOrGetter<ToolsUserRequestInput>,
 signal?: AbortSignal
) => {
      userId = toValue(userId);
toolsUserRequestInput = toValue(toolsUserRequestInput);

      return axiosClient<UserUnion>(
      {url: `/tools-users/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: toolsUserRequestInput, signal
    },
      );
    }




export const getUpdateToolsUserMutationKey = () => ['updateToolsUser'] as const;

export const getUpdateToolsUserMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateToolsUser>>, TError,UpdateToolsUserMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateToolsUser>>, TError,UpdateToolsUserMutationVariables, TContext> => {

const mutationKey = getUpdateToolsUserMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateToolsUser>>, UpdateToolsUserMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  updateToolsUser(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateToolsUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateToolsUser>>>
    export type UpdateToolsUserMutationBody = ToolsUserRequestInput
    export type UpdateToolsUserMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateToolsUserMutationVariables = {userId: string;data: ToolsUserRequestInput}

    /**
 * @summary Update Tools User
 */
export const useUpdateToolsUser = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateToolsUser>>, TError,UpdateToolsUserMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateToolsUser>>,
        TError,
        UpdateToolsUserMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateToolsUserMutationOptions(options), queryClient);
    }
